// extracted by mini-css-extract-plugin
module.exports = {"root":"skeleton_root__ws0f0","logo":"skeleton_logo__2iQgS","content":"skeleton_content__ED_7s","column":"skeleton_column__9yN_C","item":"skeleton_item__7n7lJ"};